export class ProjectActivityRequest {
    constructor(public projectName: string, public activityName: string ) {

    }
}


/** WEBPACK FOOTER **
 ** ./app/main/FineGrainedAuthorization/project-activity-request.ts
 **/